import { useEffect, } from 'react';
import { useLocation, useNavigate, } from 'react-router-dom';
import { useSetState, useMountedState, } from 'react-use';
import { useSnackbar, } from 'notistack';
import { auth, } from '../firebase/config';
import { signInWithEmailAndPassword, } from 'firebase/auth';
import { useApp, } from './useApp';

export const useLogin = () => {
    const [state, setState] = useSetState({
        isPending: false,
        error: null,
    });

    const { loginUser, } = useApp();
    const location = useLocation();
    const navigate = useNavigate();
    const isMounted = useMountedState();
    const { enqueueSnackbar, } = useSnackbar();

    const statePathname = location.state?.from?.pathname;

    const snackbarLoginError = (variant, message) => () => {
        enqueueSnackbar(message, { variant });
    };

    const login = async ({ email, password, }) => {
        setState({
            isPending: true,
            error: null,
        });

        try {
            const res = await signInWithEmailAndPassword(auth, email, password);
            loginUser(res.user);

            if (isMounted()) {
                setState({
                    isPending: false,
                    error: null,
                });
            }

            statePathname && navigate(statePathname, { replace: true, });
        } catch (error) {
            if (isMounted()) {
                setState({
                    isPending: false,
                    error,
                });
            }
        }
    };

    useEffect(() => {
        state.error && snackbarLoginError('error', state.error.message)();
    }, [state.error]);

    return {
        ...state,
        login,
    };
};